import { render } from "./Product.vue?vue&type=template&id=ce16fffa&scoped=true&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=ce16fffa&scoped=true&lang=css"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce16fffa"]])

export default __exports__